import React from 'react';

/**
 * Standard status pill. One tone → colour map for the whole portal, so the same
 * state never shows up orange on one screen and yellow on another.
 *
 * <StatusBadge tone="warning">Awaiting Approval</StatusBadge>
 * <StatusBadge tone={orderStatusTone(order)} icon={<Clock className="w-3 h-3" />}>…</StatusBadge>
 */
const TONES = {
  neutral: 'bg-gray-100 text-gray-800 border-gray-200',
  info: 'bg-blue-100 text-blue-800 border-blue-200',
  success: 'bg-green-100 text-green-800 border-green-200',
  warning: 'bg-orange-100 text-orange-800 border-orange-200',
  danger: 'bg-red-100 text-red-800 border-red-200',
};

// Order status → tone. Rows carry either a Progress ERP code or the portal's word.
const ORDER_STATUS_TONES = {
  '2': 'info',
  'in progress': 'info',
  c: 'success',
  complete: 'success',
  h: 'warning',
  'on hold': 'warning',
  pending: 'warning',
  processing: 'warning',
  x: 'danger',
  cancelled: 'danger',
};

export const orderStatusTone = (order) => {
  if (order.internal_status === 'pending_approval') return 'warning';
  return ORDER_STATUS_TONES[String(order.status || '').toLowerCase()] || 'neutral';
};

const INQUIRY_STATUS_TONES = {
  draft: 'neutral',
  submitted: 'info',
  under_review: 'info',
  quoted: 'success',
  converted: 'neutral',
  cancelled: 'danger',
};

export const inquiryStatusTone = (status) => INQUIRY_STATUS_TONES[status] || 'neutral';

const BACKORDER_STATUS_TONES = {
  pending: 'warning',
  partially_fulfilled: 'info',
  fulfilled: 'success',
};

export const backorderStatusTone = (status) => BACKORDER_STATUS_TONES[status] || 'neutral';

function StatusBadge({ tone = 'neutral', icon = null, className = '', children }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap
        ${TONES[tone] || TONES.neutral} ${className}`}
    >
      {icon}
      {children}
    </span>
  );
}

export default StatusBadge;
